import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DataTableDirective } from 'angular-datatables';
declare var $: any;
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { ProcessMasterService } from 'src/app/services/process-master.service';
import { TaskService } from 'src/app/services/task.service';
import { environment } from 'src/environments/environment';
import { AlertComponent } from '../../alert/alert.component';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-process',
  templateUrl: './process.component.html',
  styleUrls: ['./process.component.css']
})
export class ProcessComponent implements OnInit, AfterViewInit {
  isSearchDivVisible = false;
  public environmentSettings: any;

  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  // The trigger needed to re-render the table
  dtTrigger: Subject<any> = new Subject();

  dtOptionsforProcessTasks: DataTables.Settings = {};
  dtTriggerforProcessTasks: Subject<any> = new Subject();

  processMasterForm: FormGroup;
  processes: any[];
  meetingTypes: any[];
  processId: string;
  meetingtypeId: string;
  meetingType: string;
  isMeetingTask: boolean;
  processTaskId: string;
  processType: string;
  processtasklist: any[];
  SearchprocessUserdefinedorPredefinedModel: any;
  error: any = { isError: false, errorMessage: '' };
  response:boolean;
  constructor(private processMasterService: ProcessMasterService, private taskService: TaskService, 
    private alert: AlertComponent, private commonFunction: CommonFunction, private router: Router,private route: ActivatedRoute) {
    this.response = false;
   }

  ngOnInit() {

    this.environmentSettings = environment;
    
    this.commonFunction.validateURL('Process', '');
    // this.commonFunction.removeDataTableSaveStateKey("processTable");

    //this.initialiseJqueryEvents();

    let searchflag = localStorage.getItem('searchprocess');
    let searchnewdata = localStorage.getItem('inputdata');

    if(searchflag=='true'){

      this.SearchprocessUserdefinedorPredefinedModel = searchnewdata;

      this.getProcessListByProcessType(searchnewdata);   
    }
    else{
      this.getProcessList();      
    }


    this.getMeetingTypeList();
    //this.getAllPredefinedProcessTasks();

    this.dtOptions = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [3] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn process-export-btn',
          filename: 'Library Process List',
          title: 'Library Process List',
          extend: 'excel',
          exportOptions: {
            columns: [0,1,2],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
        }

        }
      ],
      initComplete: () => {
        // Initialize tooltips after DataTable initialization
        setTimeout(() => {
          this.initializeTooltips();
        }, 100);
      },
      drawCallback: () => {
        // Reinitialize tooltips after each table draw (paging, filtering, sorting)
        setTimeout(() => {
          this.initializeTooltips();
        }, 200);
      }
    };


    this.dtOptionsforProcessTasks = {
      destroy: true,
      scrollY: "430px",
      scrollX: true,
      deferRender: true,
      scrollCollapse: true,
      stateDuration: -1,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      search: true,
      order: [0, 'asc'],
      stateSave: true,
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // order: list(list(2, 'asc'), list(4, 'desc')),
      columnDefs: [{ orderable: false, targets: [3] }]
    };

    this.processMasterForm = new FormGroup({
      ProcessName: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9][a-zA-Z0-9\-\_\/ ]*[a-zA-Z]+[a-zA-Z0-9\-\_\/ ]*$")]),
      IsGlobal: new FormControl('', [Validators.required], ),
      meetingtypeId: new FormControl('', []),
    });

  }

  ngAfterViewInit() {
    // Initialize Bootstrap tooltips after view initialization
    setTimeout(() => {
      this.initializeTooltips();
    }, 100);
  }

  initializeTooltips() {
    try {
      // Destroy existing tooltips to prevent duplicates
      $('[data-toggle="tooltip"]').each(function() {
        const $this = $(this);
        if ($this.data('bs.tooltip')) {
          $this.tooltip('dispose');
        }
      });
      
      // Add tooltip to DataTables search input (on the right side)
      const searchInput = $('#processTable_filter input');
      if (searchInput.length > 0 && !searchInput.attr('data-toggle')) {
        searchInput.attr('data-toggle', 'tooltip');
        searchInput.attr('data-placement', 'top');
        searchInput.attr('title', 'Quickly find a process by entering its name or related keywords');
      }
      
      // Add tooltip attributes to Export button if it exists
      $('.process-export-btn').attr('data-toggle', 'tooltip');
      $('.process-export-btn').attr('data-placement', 'top');
      $('.process-export-btn').attr('title', 'Download the list of processes in Excel format for offline use');
      
      // Initialize tooltips for search input
      $('#processTable_filter input[data-toggle="tooltip"]').each(function() {
        const $this = $(this);
        if (!$this.data('bs.tooltip')) {
          $this.tooltip({
            container: 'body',
            trigger: 'hover',
            placement: 'top',
            delay: { show: 100, hide: 100 }
          });
        }
      });
      
      // Initialize tooltips for table buttons
      $('#processTable button[data-toggle="tooltip"]').each(function() {
        const $this = $(this);
        if (!$this.data('bs.tooltip')) {
          $this.tooltip({
            container: 'body',
            trigger: 'hover',
            placement: 'top'
          });
        }
      });
      
      // Initialize other tooltips (column headers, export button, etc.)
      $('[data-toggle="tooltip"]').not('#processTable_filter input').not('#processTable button').each(function() {
        const $this = $(this);
        if (!$this.data('bs.tooltip')) {
          $this.tooltip({
            container: 'body',
            trigger: 'hover',
            placement: 'top'
          });
        }
      });
    } catch (error) {
      console.error('Error initializing tooltips:', error);
    }
  }
  addProcessChange(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['process', 'add']  } }],
      { relativeTo: this.route.parent });
 
  }
  toggleSearchDiv() {
    this.isSearchDivVisible = !this.isSearchDivVisible;
  }

  CheckProcessType(item: any) {
    localStorage.setItem('searchprocess','true');
    localStorage.setItem('inputdata',item);
    this.processType = item;
    this.getProcessListByProcessType(this.processType);

  }

  getProcessListByProcessType(processType) {
    this.processes = [];

    if (this.dtElement && this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }

    var ispredefined = null;
    if (processType === 'Predefined') {
      ispredefined = true;
    } else if (processType === 'Userdefined') {
      ispredefined = false;
    }
    // this.processService.getProcessListByProcessType(processType)
    this.processMasterService.getProcessList()
      .subscribe(processList => {
        if (processList.status == 0) {
          var processData = $(processList.processList).filter(function (i, n) { return n.IsPredefined === ispredefined });
          this.processes = this.commonFunction.sortByKey(processData, 'ProcessName');
          this.dtTrigger.next();
          // Reinitialize tooltips after DataTable renders
          setTimeout(() => {
            this.initializeTooltips();
          }, 300);
        }
      })
  }

  loadProcessTaskToEdit(taskId, processId) {
    //console.log("taskId"+taskId+"processId"+processId);
    $('#processDialog').modal('toggle');
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['process', 'task','update',taskId,processId]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/process/task/update/', taskId, processId]);

  }

  // showProcessTasks(processId) {

  //   this.getProcessTasklistByProcessID(this.processId);
  //   $('#btnAddTasktoProcess').show();
  //   $('#btnSelectExistingTasktoProcess').show();


  // }

  // getProcessTasklistByProcessID(processId) {

  //   var processTaskTable = $('#processtaskTable').DataTable({ destroy: true });
  //   processTaskTable.destroy();

  //   this.processtasklist = [];

  //   this.taskService.getProcessTaskListByProcessID(processId)
  //     .subscribe(taskList => {
  //       if (taskList.status == 0) {

  //         this.processtasklist = taskList.processTasksDatalist

  //       }
  //       this.dtTriggerforProcessTasks.next();

  //     })
  // }


  // deleteProcessTaskConfirmation(processTaskId) {
  //   this.processTaskId = processTaskId;
  //   $('#confirmationdeleteProcessTask').modal('toggle');
  // }


  // deleteTaskProcess() {
  //   this.taskService.deleteTaskfromProcess(this.processTaskId).subscribe(data => {
  //     if (data.status == 0) {
  //       $('#confirmationdeleteProcessTask').modal('toggle');
  //       this.alert.success(data.message);
  //       this.getAllPredefinedProcessTasks();
  //     }
  //     else {
  //       $('#confirmationdeleteProcessTask').modal('toggle');
  //       this.alert.error(data.message);
  //     }
  //   });
  // }



  getProcessList() {
    this.processes = [];
    // var processTable = $('#processTable').DataTable({ destroy: true });
    // processTable.destroy();
    if (this.dtElement && this.dtElement.dtInstance != undefined) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
      });
    }
    
    this.processMasterService.getProcessList()
      .subscribe(processList => {

        if (processList.status == 0) {
          this.processes = processList.processList;
          this.response = false;          
          this.dtTrigger.next();
          // Reinitialize tooltips after DataTable renders
          setTimeout(() => {
            this.initializeTooltips();
          }, 300);
        }
      })
  }


  showAllProcesses() {
    this.response = true;
    localStorage.setItem('searchprocess','false');
    this.getProcessList()
    this.SearchprocessUserdefinedorPredefinedModel = null;
  }



  getMeetingTypeList() {
    this.meetingTypes = [];
    this.processMasterService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          this.meetingTypes = meetingTypeList.meetingTypeList;
        }
      })
  }


  showAddPopUp() {
    this.getMeetingTypeList();
    $("#myModalLabel").html('<i class="fa fa-plus"></i>Add Process');
    $('#btnsaveProcess').show();
    $('#btnupdateProcess').hide();
    this.processMasterForm.reset();
    this.processId = "";
    this.processMasterForm.controls.IsGlobal.setValue('Company');
    this.processMasterForm.controls.ProcessName.setValue('');
    this.isMeetingTask = false;
    this.meetingtypeId = "0";
    this.error = { isError: false, errorMessage: '' }

  }

  // getAllPredefinedProcessTasks() {

  //   var processTaskTable = $('#processtaskTable').DataTable({ destroy: true });
  //   processTaskTable.destroy();

  //   this.taskService.getPredefinedProcessTasks()
  //     .subscribe(taskList => {
  //       if (taskList.status == 0) {
  //         // this.companytasks = taskList.taskList;
  //         this.processtasklist = taskList.processTasksDatalist

  //       }
  //       this.dtTriggerforProcessTasks.next();
  //     })
  // }

  addProcess() {
    if (this.processMasterForm.status == "VALID") {

      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != '0' || this.processMasterForm.controls.meetingtypeId.value !='') {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      var newProcess = {
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        CreatedBy: loginUsers._id
      }

      this.processMasterService.addProcess(newProcess)
        .subscribe(process => {
          if (process.status == 0) {
            $('#processDialog').modal('toggle');
            this.alert.success(process.message);
          }
          else {
            $('#processDialog').modal('toggle');
            this.alert.error(process.message);
          }

          this.getProcessList();
          this.processMasterForm.reset();
        });

    } else {
      console.log('Invalid form submit.')
      return false;
    }
  }

  editProcess() {

    if (this.processMasterForm.status == "VALID") {
      var loginUsers = JSON.parse(localStorage.getItem("user"));
      var checkGlobal = true;
      if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
        checkGlobal = false
      }
      var meetingTypeID = null;
      if (this.processMasterForm.controls.meetingtypeId.value != '0') {
        meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
      }
      var updatedProcess = {
        ProcessId: this.processId,
        ProcessName: this.processMasterForm.controls.ProcessName.value,
        IsGlobal: checkGlobal,
        IsMeetingTask: this.isMeetingTask,
        MeetingTypeId: meetingTypeID,
        ModifiedBy: loginUsers._id
      }
      this.processMasterService.updateProcess(updatedProcess)
        .subscribe(process => {
          if (process.status == 0) {
            $('#processDialog').modal('toggle');
            this.alert.success(process.message);

          }
          else {
            $('#processDialog').modal('toggle');
            this.alert.error(process.message);
          }

          this.getProcessList();

        });
    }
    else {
      return false;
    }
  }

  deleteConfirmation(processId) {
    this.processId = processId
    $('#confirmation').modal('toggle');
  }

  deleteProcess() {
    this.processMasterService.deleteProcess(this.processId).subscribe((data:any) => {
      if (data.status == 0) {
        $('#confirmation').modal('toggle');
        this.alert.success(data.message);
      }
      else {
        $('#confirmation').modal('toggle');
        this.alert.error(data.message);
      }
      this.SearchprocessUserdefinedorPredefinedModel = null;
      this.getProcessList();
    });
  }

  //Load process by id to edit
  // loadProcessToEdit(processId) {
  //   this.processMasterService.getProcessById(processId)
  //     .subscribe(process => {
  //       if (process.status == 0) {
  //         $('#processDialog').modal('toggle') //
  //         this.processId = process.processData[0]._id;
  //         if (process.processData[0].IsGlobal) {
  //           this.processMasterForm.controls.IsGlobal.setValue('Global');
  //         }
  //         else {
  //           this.processMasterForm.controls.IsGlobal.setValue('Company');
  //         }
  //         this.processMasterForm.controls.ProcessName.setValue(process.processData[0].ProcessName);

  //         if (process.processData[0].IsMeetingTask) {
  //           //this.processMasterForm.controls.ProcessName.setValue(process.processData[0].ProcessName);
  //           this.isMeetingTask = process.processData[0].IsMeetingTask;
  //           this.meetingtypeId = process.processData[0].MeetingTypeId;
  //         }
  //         else {
  //           this.isMeetingTask = process.processData[0].IsMeetingTask;
  //           this.meetingtypeId = "0";
  //         }

  //         this.showProcessTasks(processId);

  //         $("#myModalLabel").html('<i class="fa fa-pencil"></i> Update Process');
  //         $('#btnsaveProcess').hide();
  //         $('#btnupdateProcess').show();
  //         this.error = { isError: false, errorMessage: '' }

  //       }
  //     });
  // }

  loadProcessToEdit(processId) {
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['process', 'edit',processId]  } }],
      { relativeTo: this.route.parent });
    // this.router.navigate(['/process/edit', processId]);
  }

  keyDownEnterFunction(ev) {
    if (ev.keyCode == 13) {
      if (this.processMasterForm.status == "VALID") {

        var loginUsers = JSON.parse(localStorage.getItem("user"));
        var checkGlobal = true;
        if (this.processMasterForm.controls.IsGlobal.value == 'Company') {
          checkGlobal = false
        }
        var meetingTypeID = null;
        if (this.processMasterForm.controls.meetingtypeId.value != '0') {
          meetingTypeID = this.processMasterForm.controls.meetingtypeId.value;
        }
        var newProcess = {
          ProcessName: this.processMasterForm.controls.ProcessName.value,
          IsGlobal: checkGlobal,
          IsMeetingTask: this.isMeetingTask,
          MeetingTypeId: meetingTypeID,
          CreatedBy: loginUsers._id
        }

        this.processMasterService.addProcess(newProcess)
          .subscribe(process => {
            if (process.status == 0) {
              $('#processDialog').modal('toggle');
              this.alert.success(process.message);
            }
            else {
              $('#processDialog').modal('toggle');
              this.alert.error(process.message);
            }

            this.getProcessList();
            this.processMasterForm.reset();
          });

      } else {
        console.log('Invalid form submit.')
        return false;
      }
    }
  }

  initialiseJqueryEvents() {

    $('.modal-dialog').draggable({
      handle: ".modal-header"
    });

    $('#processDialog').on('shown.bs.modal', function (e) {
      $('#processName').focus();
    });

  }

}